// #3256 -- the last signed-in scribe's NON-SECRET identity, kept in
// localStorage so a station that restarts its browser (or reloads on an
// expired token) while offline can keep running as that scribe instead of
// dead-ending on "Redirecting to login...".
//
// What is stored: the Cognito `sub` (the same id every outbox op is already
// stamped with as its owner, #1923) and the display claims TopBar shows. NEVER
// a token: the OIDC user, with its access/refresh tokens, stays in
// sessionStorage on purpose (#1561, see CogntioAuthProvider.jsx). This record
// authorizes nothing; every network call still needs a real session, and
// until there is one the calls simply fail and the outbox waits.
//
// Cleared by fullSignOut (auth/signOut.js) so a deliberate sign-out leaves
// nothing behind for the next person at the station.
const KEY = "scribe-fe.lastIdentity";
const PROFILE_FIELDS = ["given_name", "family_name", "name", "email"];

export function readLastIdentity() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed.sub === "string" && parsed.sub ? parsed : null;
  } catch {
    return null;
  }
}

export function writeLastIdentity(profile) {
  const sub = profile?.sub;
  if (!sub) return;
  const slim = { sub, profile: {} };
  for (const f of PROFILE_FIELDS) {
    if (typeof profile[f] === "string") slim.profile[f] = profile[f];
  }
  try {
    const next = JSON.stringify(slim);
    if (localStorage.getItem(KEY) !== next) localStorage.setItem(KEY, next);
  } catch {
    // Storage may be unavailable (private browsing, quota). Non-fatal: the
    // offline-first path just has nothing cached and the old behavior applies.
  }
}

export function clearLastIdentity() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // non-fatal
  }
}
